{
  "agencies.agencyCTA": "Agentur anschauen",
  "agencies.featuredAgenciesDescriptionsTitle": "Über uns",
  "agencies.featuredAgenciesGenericDescription": "Wir sind dein vertrauenswürdiger Partner in der Immobilienbranche. Unser engagiertes Team bietet dir fachkundige Beratung und persönlichen Service bei jedem Schritt.",
  "agencies.featuredAgenciesPreviewBadge": "Vorschau",
  "agencies.featuredAgenciesServicesTitle": "Dienstleistungen",
  "agencyDirectorySeoLinks.childTitle.canton": "Agenturen in Kantonen der {location}",
  "agencyDirectorySeoLinks.childTitle.country": "Agenturen in Ländern von {location}",
  "agencyDirectorySeoLinks.childTitle.default": "Agenturen in der Nähe von {location}",
  "agencyDirectorySeoLinks.childTitle.district": "Agenturen in Bezirken von {location}",
  "agencyDirectorySeoLinks.childTitle.municipality": "Agenturen in Orten von {location}",
  "agencyDirectorySeoLinks.childTitle.place": "Agenturen in Orten von {location}",
  "agencyDirectorySeoLinks.childTitle.region": "Agenturen in Regionen von {location}",
  "agencyDirectorySeoLinks.title": "Immobilienagenturen in der Nähe finden",
  "agencyFocus.any": "Alle",
  "agencyFocus.rentProperties": "Mietobjekte",
  "agencyFocus.saleProperties": "Verkaufsobjekte",
  "agencyFocusText": "Agentur-Spezialisierung",
  "agencyList.aboutUs": "Über uns",
  "agencyList.agencyTextPlural": "Agenturen",
  "agencyList.agencyTextSingular": "Agentur",
  "agencyList.featuredAgencies": "Dein Immobilienexperte vor Ort",
  "agencyList.loading": "Wird geladen...",
  "agencyList.noAgenciesFound": "Keine Agentur gefunden",
  "agencyList.rentProperties": "Immobilien zu vermieten",
  "agencyList.saleProperties": "Immobilien zu verkaufen",
  "agencyList.searchResults": "{numberOfResult} Agenturen in {location}",
  "agencyList.sorting.default": "Empfohlen",
  "agencyList.tryAnotherLocation": "Versuche es an einem anderen Ort",
  "breadcrumbs.agencyDirectory": "Alle Agenturen",
  "breadcrumbs.homepage": "Startseite",
  "searchBox.buttonText": "Agenturen suchen",
  "searchBox.inputBox.label": "Ort",
  "searchBox.inputBox.placeholder": "Ort, Region, PLZ, Land",
  "searchBox.noLocationSelectedWarning": "Bitte gib mindestens einen Ort, Region, PLZ, etc. ein.",
  "searchBox.resultButtonText": "Treffer",
  "sortingDropdown.alphabetically": "Alphabetisch",
  "sortingDropdown.rentPropertyCount.high": "Anzahl Mietobjekte: hoch",
  "sortingDropdown.salePropertyCount.high": "Anzahl Verkaufsobjekte: hoch",
  "sortingDropdown.topResults": "Vollständigkeit des Profils",
  "subHeading": "Mit einer einfachen Suche findest du den perfekten Partner für deine Bedürfnisse."
}